<div class="input-fields">
  <div class="input-field">
    <div class="input-form">
      <label class="input-label required" for="user-name"> 名前 </label>
      <input
        id="user-name"
        class="input-control"
        [placeholder]="'名前を入力してください'"
        [formControl]="name"
      />
    </div>
    <div
      class="input-error"
      [ngClass]="{
        'hide-error': !name.touched || !name.hasError('required'),
      }"
    >
      名前は必須です
    </div>
  </div>
  <div class="input-field">
    <div class="input-form">
      <label class="input-label required" for="email"> メールアドレス </label>
      <input
        id="email"
        inputmode="email"
        class="input-control"
        [placeholder]="'メールアドレスを入力してください'"
        [attr.disabled]="emailEditable ? null : 'disabled'"
        [formControl]="email"
      />
    </div>
    <div
      class="input-error"
      [ngClass]="{
        'hide-error':
          !email.touched ||
          (!email.hasError('required') && !email.hasError('invalidString')),
      }"
    >
      @if (!email.hasError('required') && !email.hasError('invalidString')) {
        <span>エラー</span>
      }
      @if (email.hasError('required')) {
        <span> メールアドレスは必須です </span>
      }
      @if (email.hasError('invalidString')) {
        <span> メールアドレスの形式が正しくありません </span>
      }
    </div>
  </div>
  <div class="input-field">
    <div class="input-form">
      <label class="input-label required" for="department"> 部署 </label>
      <input
        id="department"
        class="input-control"
        [placeholder]="'部署を入力または選択してください'"
        [formControl]="departmentName"
        [matAutocomplete]="department_auto"
      />
    </div>
    <div
      class="input-error"
      [ngClass]="{
        'hide-error':
          !departmentName.touched || !departmentName.hasError('required'),
      }"
    >
      部署は必須です
    </div>
    <mat-autocomplete #department_auto="matAutocomplete">
      @for (
        departmentName of filteredDepartmentNames | async;
        track departmentName
      ) {
        <mat-option [value]="departmentName">
          {{ departmentName }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
  <div class="input-field">
    <div class="input-form">
      <span class="input-label required"> ロール </span>
      <app-multiple-select
        [id]="'applicable-roles'"
        [items]="roleItems"
        [formControl]="roleCodes"
        (changeSelected)="changeSelectedRoles($event)"
      ></app-multiple-select>
    </div>
    <div
      class="input-error"
      [ngClass]="{
        'hide-error': !roleCodes.touched || !roleCodes.hasError('required'),
      }"
    >
      <span>ロールは必須です</span>
    </div>
  </div>
  <div class="input-field">
    <div class="input-form">
      <label class="input-label" for="report-to-input"> 上司 </label>
      @if (!reportTo.value) {
        <input
          id="report-to-input"
          class="input-control"
          [placeholder]="'上司を選択してください'"
          [formControl]="reportToInput"
          [matAutocomplete]="reportTo_auto"
          (blur)="reportToInputBlur()"
        />
        <mat-autocomplete
          #reportTo_auto="matAutocomplete"
          (optionSelected)="reportToOptionSelected($event)"
        >
          @for (user of filteredUsers | async; track user) {
            <mat-option [value]="user">
              <span>{{ user.name }}&ensp;</span>
              <span style="font-size: x-small">&lt;{{ user.email }}&gt;</span>
            </mat-option>
          }
        </mat-autocomplete>
      }
      @if (reportTo.value) {
        <div class="selected-report-to">
          <mat-chip-listbox>
            <mat-chip>
              {{ reportTo.value.name }}
              <button
                type="button"
                matChipRemove
                (click)="reportTo.setValue(null)"
              >
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-listbox>
        </div>
      }
    </div>
    <div class="input-error hide-error">
      <span>エラー</span>
    </div>
  </div>
  <div class="input-field">
    <div class="input-form">
      <span class="input-label"> ライセンス </span>
      <app-select
        [id]="'applicable-licenses'"
        [options]="selectableLicenses"
        [selectedOption]="selectedOption"
        (selectedOptionChange)="selectedOptionChange($event)"
      ></app-select>
    </div>
  </div>
  <div class="input-field">
    <div class="input-form">
      <span class="input-label">二要素認証を必須にする</span>
      <mat-checkbox class="checkbox" [formControl]="requiredMfa"></mat-checkbox>
    </div>
  </div>
  @if (user && canSeeUserPhoneNumber) {
    <div
      class="input-field phone-number-section"
      data-testid="phone-number-section"
    >
      <div class="input-form phone-number-form">
        <label class="input-label" [attr.for]="phoneNumberInputId">
          電話番号
        </label>
        <div class="phone-number-control">
          @if (phoneNumbers.length) {
            <div class="phone-number-list" role="list">
              @for (userPhoneNumber of phoneNumbers; track userPhoneNumber) {
                <div class="phone-number-row" role="listitem">
                  <span class="phone-number-value">
                    {{ userPhoneNumber.phoneNumber }}
                  </span>
                  <button
                    type="button"
                    class="phone-number-icon-button"
                    [disabled]="isPhoneNumberLoading"
                    [attr.aria-label]="'電話番号を削除'"
                    (click)="deletePhoneNumber(userPhoneNumber)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>
          }
          @if (!phoneNumbers.length) {
            <div class="phone-number-empty">登録されていません</div>
          }
          <div class="phone-number-add-row">
            <input
              [id]="phoneNumberInputId"
              inputmode="text"
              autocomplete="off"
              class="input-control phone-number-input"
              [placeholder]="'数字のみ、または VoicerecOwner（対面録音用）'"
              [formControl]="phoneNumber"
              (keydown.enter)="addPhoneNumber()"
            />
            <button
              type="button"
              class="phone-number-icon-button add-button"
              [disabled]="isPhoneNumberLoading || phoneNumber.invalid"
              [attr.aria-label]="'電話番号を追加'"
              (click)="addPhoneNumber()"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div
        class="input-error"
        [ngClass]="{
          'hide-error': !showPhoneNumberError(),
        }"
      >
        {{ phoneNumberValidationMessage() }}
      </div>
    </div>
  }
</div>
